import { NonIdealState } from '@blueprintjs/core';
import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { MappingType } from 'src/containers/ProjectDiagram/types/data';
import { getMappingType } from 'src/containers/ProjectDiagram/utils/mapping/getMappingType';
import { useMappingFromRoute } from 'src/containers/ProjectMapping/hooks/useMappingFromRoute';
import { ProjectClassMapping } from 'src/containers/ProjectMapping/ProjectClassMapping';
import { projectMappingsSelector } from 'src/selectors/projectMappings';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';
import { getProjectMappingRoute } from 'src/utils/routes/getProjectMappingRoute';

export const ProjectMappingView: React.VFC = () => {
  const { mappingId, projectId } = useRouterParams<'PROJECT_MAPPING'>();
  const mapping = useMappingFromRoute();
  const mappingType = getMappingType(mapping);

  const allMappings = useReduxSelector(projectMappingsSelector(projectId));

  if (mappingId && !mapping) {
    return <Redirect to={getProjectMappingRoute(projectId)} />;
  }

  let body: JSX.Element | null = null;
  if (mappingType === MappingType.CLASS) {
    body = <ProjectClassMapping key={mapping?.key} />;
  }
  if (mappingType === MappingType.NONE) {
    body = (
      <NonIdealState
        description={
          allMappings.length > 0
            ? copy.components.projectMapping.emptyState.description
            : ''
        }
        title={copy.components.projectMapping.emptyState.title}
      />
    );
  }

  return <div className="sd-project-mapping">{body}</div>;
};
